module.exports = __webpack_public_path__ + "img/icon-add.c2ceecfa.svg";